<template>
  <v-toolbar-items>
    <v-menu
      bottom
      offset-y
      open-on-hover
      min-width="240"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          text
          v-on="on"
        >
          <v-avatar size="36px">
            <img
              :src="currentUser.avatar"
              :alt="currentUser.name"
            >
          </v-avatar>
          <v-icon>arrow_drop_down</v-icon>
        </v-btn>
      </template>

      <v-list>
        <v-list-item v-if="adAccount">
          <v-list-item-title>
            Account ID: {{ adAccount.substr(4) }}
          </v-list-item-title>
        </v-list-item>

        <v-list-item>
          <version-switcher
            v-if="features['switch_to_app']"
          />
        </v-list-item>

        <v-list-item>
          <v-row align="center" class="ma-0">
            <v-btn outlined color="grey darken-2" @click="initIntercom">
              <v-icon left>live_help</v-icon>
              <span>Help</span>
            </v-btn>
            <v-spacer />
            <v-btn outlined color="grey darken-2" @click="logout">
              <span>Logout</span>
            </v-btn>
          </v-row>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-toolbar-items>
</template>

<script>
import { mapGetters } from 'vuex'
import Intercom from '../../Intercom'
import VersionSwitcher from './HeaderComponentToggles'
export default {
  name: 'header-component-user-info',
  components: { VersionSwitcher },
  computed: {
    ...mapGetters({
      currentUser: 'getCurrentUser',
      advertisers: 'getAdvertisers'
    }),
    features () {
      const version = this.$store.getters.getAppVersion
      return this.$store.getters.getFeatures[version]
    },
    adAccount () {
      if (!this.advertisers) return 'Not found'
      const advertiser = this.advertisers.find(a => a.id === this.currentUser.firebaseAccount.selectedAdvertiser)
      if (advertiser) return advertiser.data.ad_account
      return 'Not found'
    }
  },
  methods: {
    logout () {
      this.$router.push('/login')
      this.$store.dispatch('logout')
    },
    initIntercom () {
      const advertiser = this.currentUser.firebaseAccount.selectedAdvertiser
      const intercom = new Intercom(this.currentUser, {advertiser})
      intercom.init()
    }
  }
}
</script>
